$(document).ready(function(){
  $('.quest').click(function () {
    $(this).parent().siblings().removeClass('open');
    $(this).parents('.faqitem').siblings().find('.faqdata .items').removeClass('open');
    $(this).parent().toggleClass('open');
   
  })

  $('.faq-block-aside li').click(function(){
      $(this).addClass('active').siblings().removeClass('active')
  })

  setTimeout(function () {
    $('.faqitem:nth-child(1) .items:nth-child(1) .quest').click()
  },400)

  const menu = document.querySelector(".select-menu");
  if(menu){
    const [selectBtn, sBtnText] = [menu.querySelector(".select-btn"), menu.querySelector(".sBtn-text")];
  
    selectBtn.onclick = () => menu.classList.toggle("active");
  
      menu.querySelectorAll(".option").forEach(option => {
      option.onclick = () => {
        sBtnText.innerText = option.querySelector(".option-text").innerText;
        menu.classList.remove("active");
      };
    });
  }
})